import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Constants from "../Constants";
import { setToken } from "../utils/authFetch";
import VersionBadge from "../Components/VersionBadge";

const AUTH_ENDPOINT = Constants.AUTH_BASE_URL + "/api/v1";

const Login = () => {
  const [pswHideShow, setPswHideShow] = useState(false);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
  });

  const handleChange = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  };

  const loginSubmit = (event) => {
    setLoading(true);
    event.preventDefault();

    fetch(`${AUTH_ENDPOINT}/session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        email_address: formValues.email,
        password: formValues.password,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.user && (res.user.super_admin || res.user.is_vendor)) {
          toast.success("Logged in successfully");
          const { email, first_name, last_name, super_admin, is_vendor } = res.user;

          // Persist the session token so auth survives where the cross-site
          // cookie can't be set (Safari ITP). See utils/authFetch.js.
          setToken(res.token);
          localStorage.setItem("LoggedIn", "true");
          localStorage.setItem("super_admin", String(super_admin));
          localStorage.setItem("is_vendor", String(is_vendor));
          localStorage.setItem("email", email);
          localStorage.setItem("name", `${first_name} ${last_name}`);
          localStorage.setItem("CurrentLogin", new Date());
          if (res.previous_login_at) {
            localStorage.setItem("previousLoginAt", res.previous_login_at);
          }
          navigate("/dashboard");
        } else if (res.user && !res.user.super_admin && !res.user.is_vendor) {
          toast.error("Access denied. Admin privileges required.");
        } else {
          toast.error(res.error || "Login failed");
        }
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error.message);
        setLoading(false);
      });
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <div className="rowLoginPage">
                <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                <div className="col-lg-6 login-form">
                  <div className="p-5">
                    <div className="text-center">
                      <img
                        className="LoginLogoResponsive"
                        src="images/logo.png"
                        alt=""
                      />
                      <h1 className="h4 text-gray-900 mb-4 fw-bold">Login</h1>
                    </div>
                    <form className="user" onSubmit={loginSubmit}>
                      <div className="form-group">
                        <input
                          type="email"
                          name="email"
                          value={formValues.email}
                          onChange={handleChange}
                          className="form-control form-control-user"
                          id="exampleInputEmail"
                          aria-describedby="emailHelp"
                          placeholder="Enter Email Address..."
                        />
                      </div>
                      <div className="form-group position-relative">
                        <input
                          type={pswHideShow ? "text" : "password"}
                          name="password"
                          value={formValues.password}
                          onChange={handleChange}
                          className="form-control form-control-user"
                          id="exampleInputPassword"
                          placeholder="Password"
                        />
                        <i
                          className={`fa ${
                            pswHideShow ? "fa-eye-slash" : "fa-eye"
                          } showpswlogin-eye`}
                          aria-hidden="true"
                          onClick={() => setPswHideShow(!pswHideShow)}
                        ></i>
                      </div>
                      <div className="form-group">
                        <div className="custom-control custom-checkbox small">
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary btn-user btn-block"
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm text-Light"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          <span>Login</span>
                        )}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center" style={{ paddingBottom: "1.5rem" }}>
        <VersionBadge />
      </div>
      <Toaster />
    </div>
  );
};

export default Login;
